window.addEventListener('message', function(event) {
  if (!event.data || event.data.type !== 'BLAZE_ADD_TO_CART') return;

  const { variantId, quantity, properties } = event.data;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId),
        quantity: quantity,
        properties: properties
      }]
    })
  })
  .then(r => r.json())
  .then(() => { window.location.href = '/cart'; })
  .catch(e => console.error('Cart error:', e));
});